import { collection, onSnapshot, query } from 'firebase/firestore'
import { useEffect } from 'react'

import { useQueryClient } from 'hooks/useQueryClient'

import { db } from 'utils/firebase'

interface Props {
  roomId: string
}

export const useLiveMessageQuery = ({ roomId }: Props) => {
  const queryClient = useQueryClient()

  useEffect(() => {
    const messageQuery = query(collection(db, 'rooms', roomId, 'messages'))

    // This could be improved by using the data from the snapshot to update the queryClient
    const unsubscribe = onSnapshot(messageQuery, () => {
      queryClient.invalidateQueries(['messages', roomId])
    })

    return unsubscribe
  }, [queryClient, roomId])
}
